import React from 'react';
import { Link } from 'react-router-dom'

export default function Error() {
  return (
    <div className='top-24 absolute px-10 py-4'>
      <p className='text-white text-lg '>Page not found. Please click the devflix icon to return to homepage.</p>
    </div>
  );
}
